import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: 0,
  parentId: 0,
  logoExt: '',
  name: '',
  remember: false,
  version: '',
  modules: [],
  expirations: [],
  nav: [],
  ref: 0,
  filter: {
    'user': null,
    'location': null,
    'purposeOptional': null,
    'purposeCustom': null,
    'diver': null
  }
};

export const orgSlice = createSlice({
  name: 'org',
  initialState,
  reducers: {
    setId: (state, action) => {
      state.id = action.payload;
    },
    setParentId: (state, action) => {
      state.parentId = action.payload;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setLogoExt: (state, action) => {
      state.logoExt = action.payload;
    },
    setRemember: (state, action) => {
      state.remember = action.payload;
    },
    setVersion: (state, action) => {
      state.version = action.payload;
    },
    setModules: (state, action) => {
      state.modules = typeof action.payload === 'string' ? JSON.parse(action.payload) : action.payload;
    },
    setNav: (state, action) => {
      state.nav = action.payload;
    },
    setRef: (state, action) => {
      state.ref = action.payload;
    },
    setExpirations: (state, action) => {
      state.expirations = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = {
        ...state.filter,
        [action.payload.name]: action.payload.value 
      }
    },
    clearFilter: (state, initialState) => {
      state.filter =  {
        'user': null,
        'location': null,
        'taskOptional': null,
        'taskCustom': null,
        'diver': null,
        'divePlans': null
      }
    },
    clearOrg: () => initialState
  },
});

export const { setId, setParentId, setName, setLogoExt, setRemember, setVersion, setModules, setNav, setRef, setFilter, setExpirations, clearFilter, clearOrg } = orgSlice.actions;

export default orgSlice.reducer;